import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from 'carbon-components-react';

class EditableHeader extends Component {
  static propTypes = {
    // title: PropTypes.string,
    editBtnText: PropTypes.string,
    saveBtnText: PropTypes.string,
    onSave: PropTypes.func
  };

  static defaultProps = {
    // title: '',
    editBtnText: 'Editar',
    saveBtnText: 'Salvar',
    onSave: () => null
  };

  constructor(props) {
    super(props);

    this.state = {
      title: props.titleDefault || '',
      isEditing: false
    };
  }

  toggle = () => {
    this.setState(prevState => ({ isEditing: !prevState.isEditing }));
  };

  onChange = event => {
    this.setState({ title: event.target.value });
  };

  onSave = async () => {
    const { onSave } = this.props;
    const { title } = this.state;
    await onSave(title);
    this.toggle();
  };

  render() {
    const { title, isEditing } = this.state;
    const { editBtnText, saveBtnText, showSave, renderRigth } = this.props;

    return (
      <div>
        {!showSave && (
          <div className="content-header content-header--editable">
            <h3>{title}</h3>
            {renderRigth && renderRigth}
          </div>
        )}
        {showSave && (
          <div className="content-header content-header--editable">
            {!isEditing && <h3>{title}</h3>}
            {isEditing && (
              <TextInput
                id="name"
                labelText=""
                value={title}
                onChange={this.onChange}
              />
            )}
            {!isEditing && (
              <button
                className="button button--clear"
                type="submit"
                onClick={this.toggle}
              >
                {editBtnText}
              </button>
            )}
            {isEditing && (
              <button
                className="button button--clear"
                type="submit"
                onClick={this.onSave}
              >
                {saveBtnText}
              </button>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default EditableHeader;



// WEBPACK FOOTER //
// ./src/components/EditableHeader.js